import { execute, gql, type VariablesOf } from './financial-bff-gql'

export const CREDENTIALS_CHECK = gql(`
  query CredentialsCheck($brand: String!) {
    credentials_check(brand: $brand) {
      is_valid
      has_credentials
      access_token
    }
  }
`)

export type CredentialsCheckVariables = VariablesOf<typeof CREDENTIALS_CHECK>

export async function fetchCredentialsCheck(variables: CredentialsCheckVariables) {
  const data = await execute(CREDENTIALS_CHECK, variables)
  return data.credentials_check
}
